const SYNC_PREFIX = 'patient_sync_';

/**
 * Saves current form state to a cross-form shared storage
 * @param {string} uhid 
 * @param {object} data 
 */
export const syncPatientData = (uhid, data) => {
    if (!uhid) return;
    const existing = JSON.parse(sessionStorage.getItem(`${SYNC_PREFIX}${uhid}`) || '{}');
    const updated = { ...existing, ...data, lastSync: Date.now() };
    sessionStorage.setItem(`${SYNC_PREFIX}${uhid}`, JSON.stringify(updated));
};

/**
 * Loads shared patient data across forms
 * @param {string} uhid 
 * @returns {object}
 */
export const getSyncedPatientData = (uhid) => {
    if (!uhid) return {};
    return JSON.parse(sessionStorage.getItem(`${SYNC_PREFIX}${uhid}`) || '{}');
};

/**
 * Common Surgery Templates
 */
export const SURGERY_TEMPLATES = {
    'Appendectomy': {
        complications: 'Bleeding, Infection, Incisional hernia, Bowel injury.',
        procedure_details: 'Laparoscopic removal of appendix.',
        risks: 'General anaesthesia risks, Adhesion formation.'
    },
    'Cholecystectomy': {
        complications: 'Bile duct injury, Bile leak, Post-cholecystectomy syndrome.',
        procedure_details: 'Laparoscopic removal of gall bladder.',
        risks: 'Conversion to open surgery, General anaesthesia risks.'
    },
    'Hernia Repair': {
        complications: 'Recurrence, Chronic pain, Seroma, Hematoma.',
        procedure_details: 'Mesh repair of inguinal/umbilical hernia.',
        risks: 'Nerve injury, General anaesthesia risks.'
    },
    'TKR (Total Knee Replacement)': {
        complications: 'DVT/PE, Infection, Stiffness, Loosening of prosthesis.',
        procedure_details: 'Replacement of knee joint with artificial prosthesis.',
        risks: 'Blood loss, Nerve injury.'
    }
};
